import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, ListChecks } from 'lucide-react';

const CountdownCTA = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-2xl" style={{ backgroundColor: '#DE92A9' }} data-testid="planning-tools-cta">
          <div className="absolute inset-0 opacity-15">
            <img
              src="https://images.unsplash.com/photo-1519741497674-611481863552?w=1200&h=400&fit=crop"
              alt=""
              className="w-full h-full object-cover"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="relative z-10 py-12 md:py-16 px-8 md:px-16 flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="flex items-center gap-6">
              <div className="hidden md:flex w-20 h-20 bg-white/10 backdrop-blur-sm rounded-full items-center justify-center border border-white/20 flex-shrink-0">
                <Clock size={36} className="text-white" />
              </div>
              <div className="text-center md:text-left">
                <h3
                  className="text-2xl md:text-3xl text-white mb-2"
                  style={{ fontFamily: '"Playfair Display", serif' }}
                >
                  Counting down to "I Do"?
                </h3>
                <p className="text-white/70 text-sm md:text-base">
                  Start your personalised countdown, then tick your way through our Malta wedding checklist.
                </p>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
              <Link
                to="/countdown"
                className="group inline-flex items-center justify-center gap-2 bg-white text-[#DE92A9] px-7 py-4 rounded-full text-sm tracking-wider font-medium hover:gap-3 transition-all shadow-lg"
                data-testid="countdown-cta-link"
              >
                START COUNTDOWN
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link
                to="/checklist"
                className="group inline-flex items-center justify-center gap-2 border-2 border-white/70 text-white px-7 py-4 rounded-full text-sm tracking-wider font-medium hover:bg-white/10 transition-all"
                data-testid="checklist-cta-link"
              >
                <ListChecks size={18} />
                WEDDING CHECKLIST
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CountdownCTA;
